import { useRef } from 'react';
import Tooltip from '@mui/material/Tooltip';
import DynamicFeedIcon from '@mui/icons-material/DynamicFeed';
import AddIcon from '@mui/icons-material/Add';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { useTypedSelector } from 'hooks';
import { selectTransaction } from 'features/transactions/selectors';
import When from 'ui/support/When';

const DetailPanelExpandIcon = (props: SvgIconProps) => {
    const iconRef = useRef<SVGSVGElement>(null);

    const { children = [] } = useTypedSelector(selectTransaction({
        transactionId: iconRef.current
            ?.parentNode
            ?.parentElement
            ?.parentElement
            ?.dataset.id
    }, {}));

    return (
        <When
            if={children.length}
            then={(
                <Tooltip
                    arrow
                    title={`${children.length} child transaction(s)`}
                >
                    <DynamicFeedIcon
                        {...props}
                        ref={iconRef}
                    />
                </Tooltip>
            )}
            else={
                <AddIcon
                    {...props}
                    ref={iconRef}
                />
            }
        />
    );
};

export default DetailPanelExpandIcon;
